import { render, staticRenderFns } from "./eventdouble11P1.vue?vue&type=template&id=3a224f31&scoped=true&"
import script from "./eventdouble11P1.vue?vue&type=script&lang=js&"
export * from "./eventdouble11P1.vue?vue&type=script&lang=js&"
import style0 from "./eventdouble11P1.vue?vue&type=style&index=0&id=3a224f31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a224f31",
  null
  
)

export default component.exports